<div id="dialogUpdate">
  <div id="dialogUpdateContent">
    <span>
      Eine neue Version der Web-Bestell-App ist verfügbar.
      Die Anwendung wird geschlossen um das Update zu installieren.
      Kann die Web-Bestell-App jetzt aktualisiert werden?
    </span>
  </div>
</div>
